import React from 'react'
import moment from 'moment'
import Footer from '../controls/Footer'
import SafeImage, { SIGNATURE_PLACEHOLDER } from '../controls/SafeImage'


//  margin-top, margin-right, margin-bottom, and margin-left.
const tableStyle = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "left",
    fontSize: "12px",
  };

  const tableStyleCenter = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "center",
    fontSize: "9px"
  };

const outerTable = {
    margin: "20px 10px 2px 20px",   
    borderCollapse:"collapse",
    padding: "0",
    width: "780px",

  };

const hiddenStyle = {
    visibility: "hidden"
}

class ShowPrint extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
     const record= this.props.record
     const classes = this.props.classes
     return(
      <div >
        <table   cellPadding="10" cellSpacing="0" style={outerTable}>
        <tbody>
            <tr>
                <td>
                <table border='0' cellPadding="0" cellSpacing="0"  style={tableStyle}>
                <tbody>
                <tr>
                    <td style={{fontSize: '20px', fontWeight: 'bold', textAlign:'center' }}>APPLICANT / NEW DONOR QUESTIONNAIRE</td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td >
                        <table border='0' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                        <tbody>
                        <tr>
                            <td>NAME: First: &nbsp;&nbsp;{record.f_name}</td>
                            <td>Middle Name: &nbsp;&nbsp;{record.m_name}</td>
                            <td>Last Name: &nbsp;&nbsp;{record.l_name}</td>
                        </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td >
                        <table border='0' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                        <tbody>
                        <tr>
                            <td>HOME ADDRESS : &nbsp;&nbsp;{record.street}</td>
                            <td>CITY: &nbsp;&nbsp;{record.city}</td>
                            <td>STATE: &nbsp;&nbsp;{record.state}</td>
                            <td>ZIPCODE: &nbsp;&nbsp;{record.zip}</td>
                        </tr>
                        <tr>
                            <td colSpan='2'>TELEPHONE NUMBERS (include Area Code) : &nbsp;&nbsp;{(record.don_ph)? (record.don_ph).split(',')[0] :''}</td>
                            <td colSpan='2'>ALTERNATE NUMBER : &nbsp;&nbsp;{(record.don_ph)? ((record.don_ph).split(',')[1])? (record.don_ph).split(',')[1]  :''   :''}  </td>
                        </tr>
                        <tr>
                            <td colSpan='2'>Email  : &nbsp;&nbsp;{(record.email)}</td>
                            <td colSpan='2'>HOW DID YOU HEAR ABOUT US?  : &nbsp;&nbsp;{(record.about_us)}</td>
                        </tr>
                        <tr>
                            <td colSpan="4">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                            <table   border='1' cellPadding="5" cellSpacing="0" style={tableStyle}>
                            <tbody>
                            <tr>
                                <td>HAVE YOU HAD ANY EAR OR BODY PIERCINGS, TATTOO OR ANY TATTOO TOUCH-UPS IN THE PAST 12 MONTHS?</td>
                                <td>{record.tattoo_12}</td>                      
                                <td>Date of Last Piercing/Tattoo/Touch-Up:&nbsp;&nbsp;{(record.tattoo_12_date)?moment(record.tattoo_12_date).format('MM/DD/YYYY'):''}</td>
                            </tr>
                            <tr>
                                <td>HAVE YOU BEEN IN JAIL OR PRISON DURING THE LAST 12 MONTHS FOR A PERIOD GREATER THAN 72 HOURS?</td>
                                <td>{record.jail_72}</td>                      
                                <td>Date of Release:&nbsp;&nbsp;{(record.release_date)?moment(record.release_date).format('MM/DD/YYYY'):''}</td>
                            </tr>
                            <tr>
                                <td>DID YOU EAT SOMETHING WITHIN THE LAST 4 HOURS?</td>
                                <td>{record.eat_4}</td>                      
                                <td>What:&nbsp;&nbsp;{record.eat_4}</td>
                            </tr>
                            <tr>
                                <td>HAVE YOU EVER HAD ANY SURGERY?</td>
                                <td>{record.surgery}</td>                      
                                <td>Date of last Surgery:&nbsp;&nbsp;{(record.surgery_date)?moment(record.surgery_date).format('MM/DD/YYYY'):''}</td>
                            </tr>
                            <tr>
                                <td>IF FEMALE:  HAVE YOU BEEN PREGNANT WITHIN THE PAST 12 MONTHS?</td>
                                <td>{record.pregnant_12}</td>                      
                                <td>Date of Last Pregnancy:&nbsp;&nbsp;{(record.pregnant_date)?moment(record.pregnant_date).format('MM/DD/YYYY'):''}</td>
                            </tr>
                            <tr>
                                <td>HAVE YOU DONATED PLASMA OR BLOOD IN THE PAST?</td>
                                <td>{record.donated_plasma}</td>                      
                                <td>When:&nbsp;&nbsp;{(record.donated_date)?moment(record.donated_date).format('MM/DD/YYYY'):''}<br/>
                                    Where:&nbsp;&nbsp;{record.donated_where}</td>
                            </tr>
                            <tr>
                                <td>DO YOU HAVE A PROSTHETIC LIMB?</td>
                                <td>{record.limb}</td>                      
                                <td>Body Part:&nbsp;&nbsp;{record.body_part}</td>
                            </tr>
                            <tr>
                                <td>DO YOU TAKE ANY MEDICATIONS?<br/>
                                <font size="6px">(Include non-prescription / over-the-counter meds in your response).</font></td>
                                <td>{record.medications}</td>                      
                                <td>List of All Medications:&nbsp;&nbsp;{record.medications_list}</td>
                            </tr>
                            </tbody>
                            </table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">DONOR SIGNATURE:&nbsp;&nbsp;&nbsp;<SafeImage src={record.donor_signature} fallbackSrc={SIGNATURE_PLACEHOLDER} alt="Donor signature" className={classes.image} name= "donor_signature" /></td>
                            <td colSpan="2">DATE:&nbsp;&nbsp;{(record.sign_date)?moment(record.sign_date).format('MM/DD/YYYY'):''}</td>
                        </tr>
                        <tr>
                            <td colSpan="4"><hr /></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="4"><h3>FOR CENTER STAFF USE ONLY</h3></td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                            <table border='0' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                                <tbody>
                                    <tr>
                                        <td>PS FOLLOW-UP NEEDED:&nbsp;&nbsp;{record.follow_up}</td>
                                        <td>HEALTH HISTORIAN INITIALS:&nbsp;&nbsp;{record.hist_init}</td>
                                        <td>DATE:&nbsp;&nbsp;{(record.hist_init_date)? moment(record.hist_init_date).format('MM/DD/YYYY'):''}</td>
                                    </tr>
                                    <tr>
                                        <td>DEFERRAL CARD FILE CHECK:&nbsp;&nbsp;{record.def_check}</td>
                                        <td>INITIALS:&nbsp;&nbsp;{record.def_check_init}</td>
                                        <td>DATE:&nbsp;&nbsp;{(record.def_check_date)?moment(record.def_check_date).format('MM/DD/YYYY'):''}</td>
                                    </tr>
                                    <tr>
                                        <td>UNACCEPTABLE ADDRESS LIST CHECK:&nbsp;&nbsp;{record.address_check}</td>
                                        <td>INITIALS:&nbsp;&nbsp;{record.address_check_init}</td>
                                        <td>DATE:&nbsp;&nbsp;{(record.def_check_date)?moment(record.def_check_date).format('MM/DD/YYYY'):''}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3"><b>VEIN ASSESSMENT</b></td>
                                    </tr>
                                    <tr>
                                        <td><u>LEFT ARM:</u>   Green:&nbsp;&nbsp;{record.vein_left_g}</td>
                                        <td>Yellow:&nbsp;&nbsp;{record.vein_left_y}</td>
                                        <td>Red:&nbsp;&nbsp;{record.vein_left_r}</td>
                                    </tr>
                                    <tr>
                                        <td><u>RIGHT ARM:</u>   Green:&nbsp;&nbsp;{record.vein_right_g}</td>
                                        <td>Yellow:&nbsp;&nbsp;{record.vein_right_y}</td>
                                        <td>Red:&nbsp;&nbsp;{record.vein_right_r}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">VEIN ASSESSMENT PERFORMED BY INITIALS:&nbsp;&nbsp;{record.vein_init}</td>
                                        <td>DATE:&nbsp;&nbsp;{(record.vein_date)? moment(record.vein_date).format('MM/DD/YYYY'):''}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3">COMMENTS (IF APPLICABLE):&nbsp;&nbsp;{record.comments}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4"><hr /></td>
                        </tr>
                        <tr>
                            <td colSpan="4">&nbsp;</td>
                        </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                  <td>PHYSICIAN SUBSTITUTE EVALUATION (IF APPLICABLE):</td>
                </tr>
                <tr>
                    <td>
                        <table border='1' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                        <tbody>
                        <tr>
                            <td>
                            <table border='0' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                            <tbody>
                            <tr>
                                <td colSpan="2">{record.phy_eval}</td>
                            </tr>
                            <tr>
                                <td colSpan="2">&nbsp;</td>
                            </tr>
                            <tr>
                                <td>Physician Substitute Signature:&nbsp;&nbsp;&nbsp;<SafeImage src={record.phy_sign} fallbackSrc={SIGNATURE_PLACEHOLDER} alt="Physician substitute signature" className={classes.image} name= "phy_signature" /></td>
                                <td>Date:&nbsp;&nbsp;{(record.phy_date)? moment(record.phy_date).format('MM/DD/YYYY'):''}</td>
                            </tr>
                            </tbody>
                            </table>
                            </td>
                        </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                    <td>Is Approved?&nbsp;&nbsp;{record.is_approved ? 'Yes' : 'No'}</td>
                </tr>
                </tbody>
                </table>
                </td>
            </tr>
        </tbody>
      </table>
 
    <Footer >
        <span>Edonorsoft SOP Form No. 02.00.02, Effective 01-01-2019</span>
    </Footer>
   
 </div>
     )
    }
}

export default ShowPrint